<strong>
  @if (!showError) {
    <ng-content select="kb-hint" />
  } @else {
    <ng-content select="kb-error" />
  }
</strong>
